import { render, staticRenderFns } from "./ParticipantWitness.vue?vue&type=template&id=21d66889"
import script from "./ParticipantWitness.vue?vue&type=script&lang=js"
export * from "./ParticipantWitness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports